import React from 'react';
import _map from 'lodash/map';

class FilterLanguage extends React.Component {
    onChange = (type, e) => {
        this.props.onLanguageChange(type, e.target.checked);
    } 

    onLanguageApply = () => {
        if (this.props.onLanguageApply) {
            this.props.onLanguageApply();
        }
    }
    render() {
        const { language } = this.props;
        return (
            <React.Fragment>
                <div className="card-body search-filter-fields">
                    <div className="scroll-window">
                        <div className="scroll-window__card">
                            <label className="search-filter-fields__item custom-checkbox" htmlFor="language_any" name="language">
                                <input type="checkbox" id="language_any" name="language" className="custom-checkbox__input" checked={!this.props.language.find((la) => la.status)} onChange={(e) => {
                                    this.onChange('any', e);
                                }}  />
                                <div className="custom-checkbox__check">
                                <i className="ion ion-md-checkmark"></i>
                                </div>
                                <div className="custom-checkbox__label">
                                Any
                                </div>
                            </label>
                            {_map(language, (l, i) => (
                                <label key={i} className="search-filter-fields__item custom-checkbox" name="language">
                                    <input type="checkbox" checked={l.status} name="language" className="custom-checkbox__input" onChange={(e) => {
                                        this.onChange(l, e);
                                    }} />
                                    <div className="custom-checkbox__check">
                                    <i className="ion ion-md-checkmark"></i>
                                    </div>
                                    <div className="custom-checkbox__label">
                                        {l.value}
                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>    
                </div>
                <div className="card-footer" style={{ marginBottom: `${+this.props.headerHeight}px`}}>
                    <div onClick={() => {
                        this.onLanguageApply();
                    }} className="btn btn-green btn-footer">Apply</div>
                </div>
            </React.Fragment>
        );
    }
}

export default FilterLanguage;